import { Card } from 'component/Card'
import { Img } from 'component/Image'
import { Space } from 'component/Space'
import { useLatestCallback } from 'hook/useLatestCallback'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { ProcessingCard } from 'shared/inference/ProcessingCard'
import { controller } from 'store/controller'
import { InferenceStore } from 'store/inference/InferenceStore'
import { store } from 'store/store'
import css from './InferenceCard.module.scss'

type Props = {
  inference: InferenceStore
}

export const InferenceCard = observer(({ inference }: Props) => {
  const source = inference.sources[0]
  const { complete, error, video } = inference
  const [loaded, setLoaded] = useState(false)
  const ready = complete && !!source
  const processing = !error && (!ready || !loaded)

  const onLoad = useLatestCallback(() => {
    setLoaded(true)
  })

  const onClick = useLatestCallback(() => {
    let tab = store.inferences.tab
    if (tab === 'all') tab = inference.viewed ? 'old' : 'new'
    controller.openInference(inference, tab)
  })

  return <Card className={css.card} action={onClick}>
    {ready && <Img cover src={source} onLoad={onLoad} />}
    {processing && <Space className={css.processing}>
      <ProcessingCard inference={inference} />
    </Space>}
    {video && <Space pin={[6, 6, null, null]} center className={css.video}>
      <Icon size={10} name="videocam" fill />
    </Space>}
    {!complete && error && <Space className={css.loader} center>
      <Icon name="error" size={24} error />
    </Space>}
  </Card>
})

export const InferenceStub = () => {
  return <Card className={css.card} stub />
}
